import { render } from "./LegacyBeginOrderView.vue?vue&type=template&id=6a1c6803"
import script from "./LegacyBeginOrderView.vue?vue&type=script&lang=js"
export * from "./LegacyBeginOrderView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__